import { DashboardTimeFrame } from 'containers/dashboard/types/types';
import { usePayPeriodTimeRangeGet, useWeeklyTimeRangeGet } from 'hooks';
import { DateTime } from 'luxon';
import { useCallback } from 'react';

export default function useChartTooltipTimeFrameTitleFormatter(timeFrame: DashboardTimeFrame) {
  const weeklyRangeGet = useWeeklyTimeRangeGet('utc');
  const payPeriodRangeGet = usePayPeriodTimeRangeGet('utc');

  return useCallback(
    (day: number) => {
      switch (timeFrame) {
        case 'monthly':
          return DateTime.fromSeconds(day, { zone: 'utc' }).toFormat('MMM');
        case 'pastSeven':
        case 'pastFourteen':
        case 'daily':
          return DateTime.fromSeconds(day, { zone: 'utc' }).toFormat('L/d');
        case 'payPeriod': {
          const payPeriodRange = payPeriodRangeGet(day);
          return `${payPeriodRange.startTime.toFormat('L/d')} - ${payPeriodRange.endTime.toFormat('L/d')}`;
        }
        case 'weekly': {
          const weeklyRange = weeklyRangeGet(day);
          return `${weeklyRange.startTime.toFormat('L/d')} - ${weeklyRange.endTime.toFormat('L/d')}`;
        }
      }
    },
    [payPeriodRangeGet, timeFrame, weeklyRangeGet]
  );
}
